import { Injectable } from '@angular/core';
import { HttpService, LoyaltyResponse } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { LoginInfo, TokenResult } from '../models';

@Injectable()
export class AuthenticationService {
  constructor(private httpService: HttpService) {}

  public authenticate(loginInfo: LoginInfo): Observable<LoyaltyResponse<TokenResult>> {
    return this.httpService.makePost<LoyaltyResponse<TokenResult>, LoginInfo>('authentication', loginInfo);
  }

  public softCheck(): Observable<boolean> {
    return this.httpService.makePost<boolean, void>('softcheckauthentication', null);
  }
}
